import { Table } from 'antd'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import { onderhoudsweekend } from './queries'
import { copyToClipboard, sorter } from './helpers'

const dutchNames = {
  'name': 'naam',
  'beginOfLife': 'begin',
  'endOfLife': 'eind'
}

const columns = ['name', 'beginOfLife', 'endOfLife']
  .map((key) => ({
    title: _.startCase(dutchNames[key]),
    dataIndex: key,
    key,
    sorter: (a, b) => sorter(a[key], b[key])
  }))

const reduceOnderhoudsweekendData = (nodeSets) => (
  nodeSets.name.map((name, i) => ({
    key: i,
    name: name.value || "",
    beginOfLife: moment(nodeSets.beginOfLife[i]?.value).format('DD-MM-YYYY HH:mm') || "",
    endOfLife: moment(nodeSets.endOfLife[i]?.value).format('DD-MM-YYYY HH:mm') || ""
  }))
)

const Onderhoudsweekend = ({ quarter, ...props }) => {

  const { spaceId } = useParams()
  const { data, isLoading, error } = useQuery(
    [quarter, `${spaceId}.onderhoudsweekend.dashboard.${quarter}`],
    () => new Weaver.Sparql(onderhoudsweekend(quarter)).find()
  )

  return (
    <Table
      title={data ? copyToClipboard(reduceOnderhoudsweekendData(data)) : () => null}
      pagination={{position: ["topRight", "none"]}}
      loading={isLoading}
      bordered={true}
      columns={columns}
      dataSource={data ? reduceOnderhoudsweekendData(data) : []}
      {...props}
    />
  )
}

Onderhoudsweekend.title = "Onderhoudsweekend"

export default Onderhoudsweekend
